<template>
  <div
    class="answer-val answer-fill-sentence position-rel"
    :class="`answer-${parent.type}`"
  >
    <label class="display-flex">
      <b
        v-if="
          dataSource.code && dataSource.code !== '' && parent.answers.length > 1
        "
        >{{ dataSource.code }}
      </b>
      <div class="sentence-content">
        <v-runtime-template
          :template="contentStringFillType"
        ></v-runtime-template>
      </div>
    </label>
  </div>
</template>

<script>
import mixinsQuestionPreview from "./../../_store/mixinsQuestionPreview";
import * as types from "./../../_store/constants";
import {
  setContentQuestionFillSelect,
  resetContentQuestionFillSelect,
} from "./../../_store/helpers";
import {
  BLANK_FILL_TXT,
  BLANK_FILL_SELECT,
  BLANK_FILL_SELECT_SHORT,
} from "@/store/common/constants";
import { mapState, mapGetters, mapActions } from "vuex";
import VRuntimeTemplate from "v-runtime-template";
import { stripHtml } from "@/helpers/functions";

export default {
  name: "fillBlankOrSelect",
  mixins: [mixinsQuestionPreview],
  props: {
    dataSource: Object,
    nameField: String,
    location: Number,
    parent: Object,
    isDontShowResultSaved: Boolean,
  },
  components: {
    VRuntimeTemplate,
    // eslint-disable-next-line vue/no-unused-components
    DropdownCustom: () => import("@/components/DropdownCustom.vue"),
  },
  data() {
    return {
      types,
      contentFillType: [],
      contentStringFillType: "",
      fillSelectSplit: [],
      validate: [],
      optionSelect: [],
      answersParent: [],
    };
  },
  computed: {
    ...mapState(types.STORE_KEY, ["valVituralKeyboard"]),
    ...mapGetters({
      validate_question: `${types.STORE_KEY}/validate_question`,
      question: `${types.STORE_KEY}/question`,
    }),
  },
  watch: {
    validate_question() {
      this.convertData("validate");
    },
    question() {
      this.convertData("edit_question");
    },
    // '$route': 'resetContentFillBlank'
  },
  mounted() {
    this.convertData();
  },
  beforeDestroy() {
    // console.log('Befor destroy');
    resetContentQuestionFillSelect();
  },
  methods: {
    ...mapActions(types.STORE_KEY, [
      "setVituralKeyVal",
      "acSetTxtInputSelected",
    ]),

    displayHtmlCorrect(val) {
      // return val ? val.replace('<p>', '').replace('</p>', '') : '';
      return val ? stripHtml(val) : "";
    },

    // resetContentFillBlank() {
    // 	console.log('Func reset');
    // 	resetContentQuestionFillSelect();
    // },

    async convertData(action = null) {
      let self = this;
      // let placeholderInput = [2,3.4].includes(self.parent.layoutId) ? '?' : 'Điền đáp án';
      let placeholderInput = "?";
      // let questionIsDel = false;

      self.contentStringFillType = "";
      self.contentFillType = [];
      self.optionSelect = [];

      let typeQuestion = self.parent.type;
      // Set data options select form
      await self.converDataSelect();
      if (action !== null && self.dataSource.validate) {
        self.validate = self.dataSource.validate;
      }

      let dataContent = self.replaceContent(self.dataSource.content);

      self.contentFillType =
        (await typeQuestion) === types.TYPE_SELECT
          ? dataContent.split("</p>")
          : [self.dataSource.content];

      self.contentFillType.map((fill, index) => {
        self.fillSelectSplit[index] = fill.split(
          typeQuestion === types.TYPE_SELECT
            ? BLANK_FILL_SELECT
            : BLANK_FILL_TXT
        );
      });

      let lengthSelectOptions = self.optionSelect.length;

      // console.log('Before set content: ', self.fillSelectSplit, self.optionSelect);
      // console.log('Before set content: ', lengthSelectOptions, self.optionSelect);

      for (let i = 0; i < lengthSelectOptions; i++) {
        if (!self.optionSelect[i]) {
          // self.fillSelectSplit.splice(i, 0, ["null"]);
          self.optionSelect[i] = [{ position_del: true }];
          // questionIsDel = true;
          if (typeQuestion === types.TYPE_SELECT) {
            self.fillSelectSplit.splice(i, 0, ["null"]);
          } else {
            self.fillSelectSplit[0].splice(i, 0, "null");
          }
        }
      }

      // self.answersParent.length > 1 && self.setOptionSelectByContentFill()

      // console.log('Done split: ', self.fillSelectSplit, self.optionSelect);
      // console.log('Done split: ', self.fillSelectSplit);
      let lengthFillSplit = self.fillSelectSplit.length;

      // Save fillSelect tpl
      // Add data null in fill seect
      setContentQuestionFillSelect(self.fillSelectSplit);

      // console.log('Fill select: ', self.fillSelectSplit)

      let numFillNull = 0;
      let numSelectOrder = 0;

      self.fillSelectSplit.map((fill, index) => {
        // console.log('AHA: ', numSelectOrder)
        let fillLength = fill.length;

        // console.log('Fill arr length: ', fillLength, fill, index)
        if (index === 0) {
          self.contentStringFillType += "<div>";
        }

        if (fill && fillLength > 0) {
          // let lengthFillTxt = fill.length;
          for (let indexFill in fill) {
            let txt = fill[indexFill];
            let pos = parseInt(indexFill);
            // console.log('For of: ', pos, index + pos, index)
            // console.log('AAAAAAAAAAAAAAA', indexFill, questionIsDel, self.optionSelect[index + pos])

            // console.log('set txt pos: ', txt)
            if (txt && txt !== "null") {
              // console.log('Select post: ', index, pos)
              if (
                self.optionSelect[index + pos] &&
                self.optionSelect[index + pos][0].isDataNull
              ) {
                numFillNull += 1;
                // console.log('Plus num fill null', numFillNull)
              }

              if (
                pos === 0 &&
                txt.substring(0, 2) != "<p" &&
                !dataContent.includes("<table")
              ) {
                self.contentStringFillType += `<p>`;
              }
              if (pos < fillLength - 1) {
                let formData = ``;
                // console.log('Select: ', index, pos)
                // let indexForSetData = questionIsDel ? index + pos : pos;
                if (typeQuestion === types.TYPE_SELECT) {
                  // if (self.optionSelect[index + pos] && self.optionSelect[index + pos][0].isDataNull) {
                  // 	console.log('Plus num fill null', numFillNull)
                  // 	numFillNull += 1
                  // }
                  // let indexAnswerChoosed = self.optionSelect[index + pos] ? self.optionSelect[index + pos].findIndex(op => op.nameChoose && op.valChoose) : -1;
                  // const answerIdChoosed = Number(self.parent.answers[0].validateVal[index + pos])
                  // const positionForm = index > 0 ? pos + 1 + index : pos
                  // let positionForm = index > 0 ? pos + index : pos
                  // if (index > 1 && numFillNull > 0) {
                  // 	positionForm += index
                  // }
                  const answerIdChoosed = Number(
                    self.answersParent[self.location].validateVal[
                      numSelectOrder
                    ]
                  );

                  let indexOptionCurr = 0;
                  let indexAnswerChoosed = -1;

                  // self.optionSelect = self.optionSelect.filter(op => op[0] && !op[0].isDataNull)

                  self.optionSelect.map((op, indexAns) => {
                    // const positionAns = `${self.location}_${positionForm - numFillNull}`
                    const positionAns = `${self.location}_${numSelectOrder}`;
                    // console.log('Posi: ', positionAns, index, self.location, pos, positionForm, numFillNull)
                    if (op[0].position && op[0].position === positionAns) {
                      indexOptionCurr = indexAns;
                      indexAnswerChoosed = op.findIndex(
                        (opFind) => opFind.answerId === answerIdChoosed
                      );
                    }
                  });
                  // if (indexOptionCurr === 0) {
                  // 	indexOptionCurr = positionForm - numFillNull
                  // }
                  // console.log('Options & index: ', self.optionSelect, self.location, positionForm, numFillNull, pos, index)

                  // let indexAnswerChoosed = answerIdChoosed ? self.optionSelect[index + pos + numFillNull].findIndex(op => op.answerId === answerIdChoosed) : -1;
                  // let indexAnswerChoosed = answerIdChoosed ? self.optionSelect[self.indexOptionCurr].findIndex(op => op.answerId === answerIdChoosed) : -1;

                  // console.log('Index answer Choose: ', indexFill, index, self.location, index + pos, index + pos + numFillNull, numFillNull, self.optionSelect[index + pos])
                  // console.log('aaaaaa: ', indexOptionCurr, indexAnswerChoosed)
                  // console.log('AAAAAA: ', indexAnswerChoosed, self.parent.answers[0].validateVal, answerIdChoosed, self.optionSelect[index + pos + numFillNull]);
                  // let nameChoosed = indexAnswerChoosed > -1 ? self.optionSelect[pos][indexAnswerChoosed]['nameChoose'] : '?';
                  // let valChoosed = indexAnswerChoosed > -1 ? self.optionSelect[pos][indexAnswerChoosed]['valChoose'] : null;
                  // console.log('Name choose: ', nameChoosed, self.optionSelect, index, pos)
                  // const indexOption = self.optionSelect[index + pos][0].isDataNull ? (index + pos) + 1 : index + pos
                  // Comment set old value 18-8-2021
                  // :valoptionActive="${indexAnswerChoosed} > -1 ? optionSelect[${index + pos + numFillNull}][${indexAnswerChoosed}]['valChoose'] : null"
                  // :options="optionSelect[${index + pos + numFillNull}]"
                  // :position="${index + pos}"
                  formData = `
											<DropdownCustom 
												:nameOptionDefault="${indexAnswerChoosed} > -1 ? optionSelect[${indexOptionCurr}][${indexAnswerChoosed}]['content'] : '?'"
												:valoptionActive="${indexAnswerChoosed} > -1 ? ${answerIdChoosed} : null"
												:options="optionSelect[${indexOptionCurr}]"
												:optionValueKey="'answerId'"
												:optionNameKey="'content'"
												:location="location"
												:type="parent.type"
												:position="${indexOptionCurr}"
												:class="{
													'error': !isDontShowResultSaved && dataSource.validate && dataSource.validate.length > 0 && (!dataSource.validate[${numSelectOrder}] || dataSource.validate[${numSelectOrder}] === 'false'),
													'success': !isDontShowResultSaved && dataSource.validate && dataSource.validate.length > 0 && dataSource.validate[${numSelectOrder}] && dataSource.validate[${numSelectOrder}] !== 'false'
												}"
												@changeSelect="changeValSelect"
											/>
										`;
                  if (fillLength > 1 && pos < fillLength - 1) {
                    numSelectOrder += 1;
                  }
                } else {
                  // Tự điều chỉnh độ rộng của input
                  // ModifiedBy: anhdd (11/1/2023)
                  formData = `<label class="form-control label-answer" 
                  :class="{
															'error': !isDontShowResultSaved && dataSource.validate && dataSource.validate.length > 0 && (!dataSource.validate[${
                                index + pos
                              }] || dataSource.validate[${
                    index + pos
                  }] === 'false'), 
															'success': !isDontShowResultSaved && dataSource.validate && dataSource.validate.length > 0 && dataSource.validate[${
                                index + pos
                              }] && dataSource.validate[${
                    index + pos
                  }] !== 'false',
														}"
                             v-if="parent.isWorked !== null">
      {{ dataSource.validateVal && dataSource.validateVal.length > 0 && dataSource.validateVal[${
        index + pos
      }] ? displayHtmlCorrect(dataSource.validateVal[${index + pos}]) : '' }}
    </label>

                  <input v-else 
														class="display-inline text-center input-hide-place hahahaokok" 
														:id="'fill_blank_' + location + ${index + pos} + dataSource.answerId"
														:value="dataSource.validateVal && dataSource.validateVal.length > 0 && dataSource.validateVal[${
                              index + pos
                            }] ? displayHtmlCorrect(dataSource.validateVal[${
                    index + pos
                  }]) : ''"
														@keyup="handleFocus($event, {answerId: dataSource.answerId, location, type: parent.type, questionId: dataSource.questionId, fill_index: ${
                              index + pos
                            }})"
														@focus="handleFocus($event, {answerId: dataSource.answerId, location, type: parent.type, questionId: dataSource.questionId, fill_index: ${
                              index + pos
                            }})"
														@change="changeAnswer($event, {answerId: dataSource.answerId, location, type: parent.type, questionId: dataSource.questionId, fill_index: ${
                              index + pos
                            }})"
														@blur="changeAnswer($event, {answerId: dataSource.answerId, location, type: parent.type, questionId: dataSource.questionId, fill_index: ${
                              index + pos
                            }})"
														@mouseup="handleMouseSelection($event)"
                            placeholder="${placeholderInput}" 
														:disabled="parent.isWorked !== null"
														:class="{
															'error': !isDontShowResultSaved && dataSource.validate && dataSource.validate.length > 0 && (!dataSource.validate[${
                                index + pos
                              }] || dataSource.validate[${
                    index + pos
                  }] === 'false'), 
															'success': !isDontShowResultSaved && dataSource.validate && dataSource.validate.length > 0 && dataSource.validate[${
                                index + pos
                              }] && dataSource.validate[${
                    index + pos
                  }] !== 'false',
														}"
                            autocomplete="off"
                            onInput="this.parentNode.dataset.value = this.value"
        size="1"
													/>
                          `;
                }
                // :disabled="parent.isTrue !== null"

                self.contentStringFillType += `${txt}${formData}`;
              }
              if (pos === fillLength - 1) {
                self.contentStringFillType += `${txt}</p>`;
              }
            }
          }
        }
        // console.log('Index fill: ', index)
        if (index === lengthFillSplit - 1) {
          // console.log('End tag', index, lengthFillSplit)
          self.contentStringFillType += "</div>";
        }
      });
    },

    replaceContent(content) {
      let textNeedReplace = new RegExp(
        this.parent.type === types.TYPE_SELECT
          ? BLANK_FILL_SELECT_SHORT
          : BLANK_FILL_TXT,
        "gi"
      );
      return content.replace(
        textNeedReplace,
        `${
          this.parent.type === types.TYPE_SELECT
            ? BLANK_FILL_SELECT_SHORT
            : BLANK_FILL_TXT
        }&nbsp;`
      );
    },

    setOptionSelectByContentFill() {
      let self = this;
      let lengthFill = self.fillSelectSplit.length;
      self.fillSelectSplit.map((fill, index) => {
        // if((!fill || ( fill.length === 1 && !fill[0])) && index < lengthFill - 1 && self.question.type !== types.TYPE_SELECT) {
        // 	self.optionSelect.splice(index, 0, [{isDataNull: true}]);
        // } else
        if ((!fill || fill.length === 1) && index < lengthFill - 1) {
          self.optionSelect.splice(index, 0, [{ isDataNull: true }]);
        }
      });
    },

    converDataSelect() {
      let self = this;
      self.parent.answers.map((ans) => {
        if (ans.position) {
          let positionItem = ans.position.split("_");
          if (parseInt(positionItem[0]) === parseInt(self.location)) {
            if (self.optionSelect[positionItem[1]]) {
              self.optionSelect[positionItem[1]].push(ans);
            } else {
              self.optionSelect[positionItem[1]] = [ans];
            }
          }
        } else {
          self.answersParent.push(ans);
        }
      });
    },

    countChildAnswer(indexP, positionChar, arrChar) {
      let result = 0;
      arrChar.map((da, index) => {
        if (index < indexP) {
          result += arrChar[index].length - 1 + positionChar;
        }
      });
      return result;
    },

    changeValSelect(val) {
      // console.log('Set val select: ', val)
      this.parent.answers.map((ans) => {
        if (ans.position && ans.position === `${val.location}_${val.index}`) {
          if (ans.answerId === val.evt.target.value) {
            ans["nameChoose"] = val.nameChoose;
            ans["valChoose"] = val.valChoose;
          } else {
            ans.nameChoose && delete ans.nameChoose;
            ans.valChoose && delete ans.valChoose;
          }
        }
      });
      this.changeAnswer(
        { ...val.evt },
        {
          location: val.location,
          type: val.type,
          select_index: val.index,
          position_display: val.position_display,
        }
      );
    },

    handleFocus(val, info = {}) {
      console.log(val);
      this.handleMouseSelection(val);
      let halfWindowHeight = window.innerHeight / 2;
      let offsetTopElm = document
        .getElementById(
          `fill_blank_${info.location}${info.fill_index}${info.answerId}`
        )
        .getBoundingClientRect().top;
      let offsetLeftElm = document
        .getElementById(
          `fill_blank_${info.location}${info.fill_index}${info.answerId}`
        )
        .getBoundingClientRect().left;
      // input position > 80% screen
      let spaceHeightInput =
        (offsetTopElm / window.innerHeight) * 100 > 80 ? 20 : 50; // 50 or 20 is height input
      // Obj have ref key support render value onpress vitural keyboard
      this.setVituralKeyVal({
        ...info,
        val: val.target.value,
        ref: `fill_blank_${info.location}${info.fill_index}${info.answerId}`,
        isOverHaflScreen: offsetTopElm > halfWindowHeight ? true : false,
        top: offsetTopElm + spaceHeightInput,
        left: offsetLeftElm / 2, // /2 is box center
      });
    },

    handleMouseSelection(evt) {
      let value = evt.target.value;
      this.txtSelection = evt.target.value.slice(
        evt.target.selectionStart,
        evt.target.selectionEnd
      );
      if (this.txtSelection) {
        let lengthTxt = value.length;
        let firstTxt = value.slice(0, evt.target.selectionStart);
        let lastTxt = value.slice(evt.target.selectionEnd, lengthTxt);
        this.acSetTxtInputSelected([firstTxt, lastTxt]);
      } else {
        this.acSetTxtInputSelected([]);
      }
    },
  },
};
</script>

<style lang="scss">
// @media (max-width: 1024px){
// 	.answer-val{
// 		.sentence-content{
// 		}
// 	}
// }

// Tự điều chỉnh độ rộng của combobox
// ModifiedBy: anhdd (11/1/2023)
.question--select .answer .dropdown-custom {
  margin: 2px 5px !important;
}
.dropdown-custom__display {
  height: auto !important;
  padding: 0 27px 0 5px !important;
  overflow: inherit !important;
}
.dropdown-custom__display i {
  bottom: 0;
}
.dropdown-custom__options {
  min-width: max-content !important;
}

// Tự điều chỉnh độ rộng của input
// ModifiedBy: anhdd (11/1/2023)
.input-sizer {
  display: inline-grid !important;
  vertical-align: top !important;
  align-items: center !important;
  background-color: #fff;
  margin: 0 8px 3px;
  &.stacked {
    align-items: stretch !important;

    &::after,
    input,
    textarea {
      grid-area: 2 / 1;
    }
  }

  &::after,
  input,
  textarea {
    width: auto !important;
    grid-area: 1 / 2;
    resize: none !important;
    background: none !important;
    appearance: none !important;
  }

  &::after {
    content: attr(data-value) " ";
    visibility: hidden !important;
    white-space: pre-wrap !important;
  }

  &:focus-within {
    textarea:focus,
    input:focus {
      outline: none !important;
    }
  }
}

.input-sizer input {
  margin: 0 !important;
  padding: 0 !important;
  min-width: 70px;
}

.label-answer {
  background: #f3f6fb;
  font-weight: 700;
  color: #0f3dba;
  display: inline;
  margin: 0 4px;
}
.label-answer.error {
  border: 1px solid #f46055 !important;
}
.label-answer.success {
  border: 1px solid #5fcea1 !important;
}
</style>